<template>
  <div>
    <v-card class="elevation-10">
      <v-card-title>
        <span class="headline font-weight-black">Credit Details</span>
      </v-card-title>
      <v-divider></v-divider>
      <br />
      <table style="table-layout: fixed;">
        <tr>
          <th>Card No</th>
          <td>{{ data.card_no }}</td>
          <th>Time End</th>
          <td class="text-xs-center">{{ data.time_end }}</td>
        </tr>
        <tr>
          <th>Verification Code</th>
          <td>{{ data.verification_code }}</td>
          <th>Date Redeemed</th>
          <td class="text-xs-center">{{ data.date_redeemed }}</td>
        </tr>
        <tr>
          <th>Date Created</th>
          <td class="text-xs-center">{{ data.date_created }}</td>
          <th>Time Redeemed</th>
          <td class="text-xs-center">{{ data.time_redeemed }}</td>
        </tr>
        <tr>
          <th>Time Created</th>
          <td class="text-xs-center">{{ data.time_created }}</td>
          <th>Status</th>
          <td class="text-xs-center">{{ data.status }}</td>
        </tr>
        <tr>
          <th>Date Start</th>
          <td class="text-xs-center">{{ data.date_start }}</td>
          <th>Type</th>
          <td class="text-xs-center">{{ data.type }}</td>
        </tr>
        <tr>
          <th>Time Start</th>
          <td class="text-xs-center">{{ data.time_start }}</td>
          <th>Value</th>
          <td class="text-xs-right">{{ data.value }}</td>
        </tr>
        <tr>
          <th>Date End</th>
          <td class="text-xs-center">{{ data.date_end }}</td>
          <th>Remarks</th>
          <td>{{ data.remarks }}</td>
        </tr>
        <tr>
          <th>Cancel Remarks</th>
          <td colspan="3">{{ data.cancel_remarks }}</td>
        </tr>
      </table>
    </v-card>
    <br />
    <br />
    <v-card v-if="data.card_transaction_sync === null" class="pa-3">
      <span class="title font-weight-medium">Transaction not yet sync.</span>
    </v-card>
    <v-card class="elevation-10" v-if="data.card_transaction_sync !== null">
      <v-card-title>
        <span class="headline font-weight-black">Transaction Details</span>
      </v-card-title>
      <v-divider></v-divider>
      <br />
      <table>
        <tr>
          <th>Card Amount</th>
          <td class="text-xs-right">{{ $amountInPeso(data.card_transaction_sync.card_amount) }}</td>
          <th>Previous Balance</th>
          <td class="text-xs-right">{{ $amountInPeso(data.card_transaction_sync.previous_balance) }}</td>
        </tr>
        <tr>
          <th>Card Cost</th>
          <td class="text-xs-right">{{ $amountInPeso(data.card_transaction_sync.card_cost) }}</td>
          <th>Remaining Balance</th>
          <td
            class="text-xs-right"
          >{{ $amountInPeso(data.card_transaction_sync.remaining_balance) }}</td>
        </tr>
        <tr>
          <th>Card No</th>
          <td>{{ data.card_transaction_sync.card_no }}</td>
          <th>Trace No</th>
          <td>{{ data.card_transaction_sync.trace_no }}</td>
        </tr>
        <tr>
          <th>Card Value</th>
          <td class="text-xs-right">{{ $amountInPeso(data.card_transaction_sync.card_value) }}</td>
          <th>Transaction Amount</th>
          <td
            class="text-xs-right"
          >{{ $amountInPeso(data.card_transaction_sync.transaction_amount) }}</td>
        </tr>
        <tr>
          <th>Control No</th>
          <td>{{ data.card_transaction_sync.control_no }}</td>
          <th>Transaction Date</th>
          <td class="text-xs-center">
            {{
            $dateFormat(
            data.card_transaction_sync.transaction_date,
            "YYYY-MM-DD"
            )
            }}
          </td>
        </tr>
        <tr>
          <th>Coordinates</th>
          <td class="text-xs-center" style="cursor: pointer; color: blue;" @click="openMap">
            {{
            data.card_transaction_sync.lat +
            "," +
            data.card_transaction_sync.long
            }}
          </td>
          <th>Transaction No</th>
          <td>{{ data.card_transaction_sync.transaction_no }}</td>
        </tr>
        <tr>
          <th>Loyalty Point</th>
          <td>{{ data.card_transaction_sync.loyalty_point }}</td>
          <th>Agent</th>
          <td
            class="text-xs-center"
          >{{ data.card_transaction_sync.user.first_name +" "+ data.card_transaction_sync.user.last_name}}</td>
        </tr>
      </table>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    readonly: Boolean
  },
  methods: {
    openMap() {
      this.$emit("openMap", {
        lat: this.data.card_transaction_sync.lat,
        long: this.data.card_transaction_sync.long
      });
    }
  }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

th {
  border: 3px solid #000000;
  text-align: left;
  padding: 12px;
  font-size: 16px;
  background-color: #f5f5f5;
}

td {
  border: 2px solid #000000;
  text-align: left;
  font-size: 16px;
  padding: 8px;
}
</style>
